import React from 'react';
import { Heart, Users, BookOpen } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-intro">
          <div className="section-icon">✨</div>
          <p className="about-description">
            Le Maître Dia, grand marabout africain à Bruxelles, est issu d'une longue tradition de médiums 
            d'Afrique de l'Ouest. Il est spécialisé dans le retour affectif, l'envoûtement amoureux, 
            le mariage, les permis de construire, et la protection contre le mauvais œil. 
            La rapidité de ses résultats est différente des autres. Il aide ses clients à 
            retrouver l'être aimé et à surmonter tous les obstacles de la vie.
          </p>
          <Link to="/contact">
            <Button className="contact-btn-section">
              CONTACTER LE MAÎTRE DIA
            </Button>
          </Link>
        </div>

        <div className="about-expertise">
          <p className="expertise-text">
            Marabout voyant médium guérisseur puissant, le Maître Dia offre un accompagnement 
            spirituel efficace et rapide. Ses services incluent le retour affectif rapide, 
            retrouver l'être aimé, l'envoûtement amoureux, la réussite dans le mariage, 
            l'obtention de permis de construire, et la protection puissante contre le mauvais œil. 
            La rapidité de ses résultats est reconnue et différente des autres marabouts. 
            Il garantit des solutions concrètes et rapides pour tous les problèmes de ses clients.
          </p>
          <Link to="/contact">
            <Button className="contact-btn-section">
              CONTACTER LE MAÎTRE DIA
            </Button>
          </Link>
        </div>

        <div className="gifts-section">
          <div className="section-icon">✨</div>
          <h2 className="gifts-title">Les dons de clairvoyance</h2>
          
          <div className="gifts-grid">
            <div className="gift-card">
              <Heart className="gift-icon" size={48} />
              <p>
                Le Maître Dia offre consultation et écoute bienveillante pour accompagner 
                ses clients dans leurs démarches spirituelles
              </p>
            </div>

            <div className="gift-card">
              <Users className="gift-icon" size={48} />
              <p>
                Il communique avec les ancêtres et établit des connexions spirituelles 
                avec les personnes disparues
              </p>
            </div>

            <div className="gift-card">
              <BookOpen className="gift-icon" size={48} />
              <p>
                Il prodigue des conseils avisés et une guidance pour les prises de décision 
                importantes dans la vie
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
